// extracted by mini-css-extract-plugin
module.exports = {"edit-price-button":"EditPriceButton_edit-price-button__38sXU","restricted":"EditPriceButton_restricted__3W6Bc"};